import React from 'react';
import { Button } from 'antd';

interface JSONPanelProps {
  graphData: {
    nodes: any[];
    edges: any[];
    _timestamp?: number;
  };
  onRefresh?: () => void;
}

const JSONPanel: React.FC<JSONPanelProps> = ({ graphData, onRefresh }) => {
  const handleCopyJsonData = async () => {
    try {
      const data = JSON.stringify(graphData, null, 2);
      await navigator.clipboard.writeText(data);
      console.log('JSON数据已复制到剪贴板');
    } catch (error) {
      console.error('复制失败:', error);
    }
  };

  const handleRefresh = () => {
    console.log('🔄 手动刷新JSON数据');
    if (onRefresh) {
      onRefresh();
    }
  };

  return (
    <div className="panel-content">
      <div className="panel-header">
        <h3>JSON数据</h3>
        <div className="panel-actions">
          <Button
            onClick={handleRefresh}
            size="small"
            type="default"
            style={{ marginRight: 8 }}
          >
            🔄 刷新
          </Button>
          <Button onClick={handleCopyJsonData} size="small" type="default">
            📋 复制JSON
          </Button>
        </div>
      </div>
      <div className="json-display">
        <pre
          style={{
            margin: 0,
            padding: 0,
            background: 'transparent',
            border: 'none',
          }}
        >
          {JSON.stringify(graphData, null, 2)}
        </pre>
      </div>
    </div>
  );
};

export default JSONPanel;
